import { ChangeDetectionStrategy, Component, computed, effect, inject, input, output, untracked} from '@angular/core';
import { FieldTextComponent, FieldNumberComponent, FieldSelectComponent, AbstractFormArrayComponent } from '@spike/scaffolds';
import { Button } from "primeng/button";
import { TableModule } from "primeng/table";
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormFactoryService } from '../../../shared/services/form-factory.service';
import { OrganizationListComponent } from "../../../organizations/components/organization-list/organization-list";
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { startWith, switchMap } from 'rxjs';
import { OrganizationStoreService } from '../../../organizations/services/organization-store.service';
import { Material } from '../../models/material.model';
import { EntityApiEnum, EtiquetteApiEnum, ModelApiEnum } from 'src/app/config/entity-api.enum';


@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-position-materials-form',
  providers:[],
  imports: [CommonModule, ReactiveFormsModule, FormsModule, Button, TableModule, CommonModule, FormsModule, FieldTextComponent, FieldNumberComponent, FieldSelectComponent, OrganizationListComponent],
  templateUrl: './position-materials-form.html'
})

export class PositionMaterialsFormComponent extends AbstractFormArrayComponent{
  private readonly formFactory = inject(FormFactoryService);
  public readonly organizationStore = inject(OrganizationStoreService);

  workingPhase=input.required<number>();
  showRequest =input.required<boolean>();
  addRow = output<void>();
  deleteRow = output<number>();
  calculateTotal = output<number>();
  createRequest = output<Material>();

  equipmentApi= EntityApiEnum.EQUIPMENT;
  equipmentModelApi= ModelApiEnum.EQUIPMENT;
  equipmentEtiquetteApi= EtiquetteApiEnum.EQUIPMENT;  
  
  equipmentForm = this.formFactory.createEquipmentForm();

  showCost=computed(()=>{
    const workingPhase =this.workingPhase();
    return workingPhase==1;
  });
 
 
  private readonly formValues = toSignal(
    toObservable(this.form).pipe(
      switchMap(array => array.valueChanges.pipe(
        startWith(array.getRawValue())
      ))
    )
  );
  
  constructor() {
    super();

    effect(() => {
      const currentValues = this.formValues();
      const isEditing = !this.isFormDisabled();

      if (isEditing && currentValues) {
        let total = 0;

        this.form().controls.forEach((control, index) => {
          const rowValue = currentValues[index];
          if (!rowValue) return;

          const costControl = control.get('cost');
          total += Number(costControl?.value ?? 0);
        });

        untracked(() => {
          this.calculateTotal.emit(total);
        });
      }
    });
  }

}
  

